import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, isRef as _isRef, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, normalizeClass as _normalizeClass, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-8aaf58c8"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "d-flex justify-content--between align-items-center mt-10" }
const _hoisted_2 = { class: "d-flex align-items-center" }
const _hoisted_3 = /*#__PURE__*/_createTextVNode("   月   ")
const _hoisted_4 = /*#__PURE__*/_createTextVNode("   周   ")
const _hoisted_5 = /*#__PURE__*/_createTextVNode("   天   ")
const _hoisted_6 = /*#__PURE__*/_createTextVNode("设置")
const _hoisted_7 = { class: "d-flex align-items-center" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "ml-10" }, "文件下载详情", -1))
const _hoisted_9 = { class: "detalisListBox" }
const _hoisted_10 = { class: "downloadBox" }
const _hoisted_11 = ["onClick"]
const _hoisted_12 = { key: 1 }
const _hoisted_13 = { class: "userDetailsListBox" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "用户下载详情", -1))
const _hoisted_15 = ["onClick"]
const _hoisted_16 = { class: "mr-10 d-inline-flex align-items-center" }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "告警阈值", -1))
const _hoisted_18 = /*#__PURE__*/_createTextVNode()
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "个", -1))
const _hoisted_20 = { class: "ml-30 mr-10 d-inline-flex align-items-center" }
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "通知提醒", -1))
const _hoisted_22 = /*#__PURE__*/_createTextVNode()
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "天", -1))
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "通知提醒设置不为0时，超过告警闻值的用户将会收到如下的邮件提醒", -1))
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "标题", -1))
const _hoisted_26 = { class: "mt-10 setDialogFoot" }
const _hoisted_27 = /*#__PURE__*/_createTextVNode("取消")
const _hoisted_28 = /*#__PURE__*/_createTextVNode("确定")
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "mt-10" }, "注意", -1))
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "1. CO3 测试环境转 PDF 验证通过的文档类型，才能填写", -1))
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "2. 注意填写正确且为全小写的文件后缀，多个文件类型用英文逗号隔开(不需要空格)，如： doc,docx,ppt", -1))
const _hoisted_32 = { class: "mt-10 setDialogFoot" }
const _hoisted_33 = /*#__PURE__*/_createTextVNode("取消")
const _hoisted_34 = /*#__PURE__*/_createTextVNode("确定")
const _hoisted_35 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "mt-10" }, "禁用字体添加说明：", -1))
const _hoisted_36 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "1. 请先了解哪些字体需要列为禁用字体 ", -1))
const _hoisted_37 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "2. 提供测试文档，发送给文档管理的开发人员，获取实际的字体名称", -1))
const _hoisted_38 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "3. 开发人员告知的字体名称后，只需要填写字体的关键字即可", -1))
const _hoisted_39 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "4. 每个字体名称用英文逗号隔开，如：MicrosoftYaHei,FZLTTHJW", -1))
const _hoisted_40 = { class: "mt-10 setDialogFoot" }
const _hoisted_41 = /*#__PURE__*/_createTextVNode("取消")
const _hoisted_42 = /*#__PURE__*/_createTextVNode("确定")

import {ref, computed, onBeforeMount, onActivated} from 'vue'
import tbMix from '@/global_mixin/tableMixin'
import dayjs from "dayjs";
import { formatTime, exportHandle } from '@/utils/index'
import Api from '@/http/modules/index'
import { ElMessage } from 'element-plus';

export default /*#__PURE__*/_defineComponent({
  setup(__props) {

let {
  // 文件下载详情
  'POST/drive/download/details': fileDetailsApi,
  // 下载的导出详情Excel
  'POST/drive/download/details/export': exportExcelApi,
  // 用户下载详情
  'POST/drive/download/details/statistics': statisticsUserApi,
  // 获取警告阈值
  'GET/drive/download/setting': getAlarmApi,
  // 设置警告阈值
  'POST/drive/download/setting': setAlarmApi,
  // 设置需要一起上传pdf的文件类型
  'POST/drive/download/setting/file_type': settingfile_typeApi, 
  // 设置禁用字体
  'POST/drive/download/setting/disabled_font':settingDisabledFontApi
} = Api
const { 
  MI_tableData, fetchData, page, size, MI_total, MI_pageChange,
  MI_sizeChange, MI_identify, MI_params, MI_modifyForm, MI_height
} = new tbMix(fileDetailsApi)
const { 
  MI_tableData: userDownloadTable, fetchData: fetchUserData, MI_identify: user_identify, MI_params: user_params, 
} = new tbMix(statisticsUserApi)

let alarmThreshold = ref<number>(0) //告警阈值
let remindDay = ref<number>(0) // 通知提醒天数
let title = ref<string>('')
let content = ref<string>('')
let toPdfStr = ref('') // 需要绑定上传pdf的文件类型

let realAlarmVal = ref<number>(0)
let rangeType = ref('0')
let detailsDate = ref<string[]>([dayjs().subtract(1, 'month').format('YYYY-MM-DD'), dayjs().format('YYYY-MM-DD')])


const alarmBtnFg = ref<boolean>(false)
// 获取阈值
const getAlarmHandle = () => {
  alarmBtnFg.value = true 
  getAlarmApi().then((rep: any) => {
    // 绑定的阈值
    alarmThreshold.value = rep.alarmThreshold
    remindDay.value = rep.remindDay
    title.value = rep.title
    content.value = rep.content
    toPdfStr.value = rep.fileType
    // 真实的阈值
    realAlarmVal.value = rep.alarmThreshold
    illegalFonts.value=rep.disabledFont

    alarmBtnFg.value = false
  }).catch(() => {
    alarmBtnFg.value = false
  })
}


// 设置告警阈值
const settingFg = ref<boolean>(false)
const showSetHandle =  () => {
  settingFg.value = true
  /* alarmBtnFg.value = true 
  setAlarmApi({setting: val}, {contentType: 'formData'}).then(() => {
    ElMessage.success('设置成功')
    alarmBtnFg.value = false
    getAlarmHandle()
  }).catch(() => {
    alarmBtnFg.value = false
  }) */
}

const setAlarmHandle = () => {
  alarmBtnFg.value = true
  setAlarmApi({
    alarmThreshold: alarmThreshold.value || 0,
    remindDay: remindDay.value || 0,
    title: title.value,
    content: content.value,
  }).then(() => {
    ElMessage.success('设置成功')
    settingFg.value = false
    alarmBtnFg.value = false

    getAlarmHandle()
  }).catch(() => {
    alarmBtnFg.value = false
  })
}

const cancelAlarm = () => {
  // 关闭弹窗,重置设置内容
  settingFg.value = false
  illegalFonts.value=""
  getAlarmHandle()
}

// 文件下载详情参数
const detalisParams = computed(() => {
  return {
    startDate: detailsDate.value[0],
    endDate: detailsDate.value[1],
    userId: '',
  }
})

// 搜索文件下载详情
const quickSearch = (type?: string) => {
  switch (type) {
    case '0':
      rangeType.value = type
      detailsDate.value = [dayjs().subtract(1, 'month').format('YYYY-MM-DD'), dayjs().format('YYYY-MM-DD')]
      break;
    case '1':
      rangeType.value = type
      detailsDate.value = [dayjs().subtract(1, 'week').format('YYYY-MM-DD'), dayjs().format('YYYY-MM-DD')]
      break;
    case '2':
      rangeType.value = type
      detailsDate.value = [dayjs().subtract(1, 'day').format('YYYY-MM-DD'), dayjs().format('YYYY-MM-DD')]
      break;
  
    default:
      break;
  }

  searchHandle()
}
const dataChangeHandle = () => {
  let duration = dayjs(detalisParams.value.endDate).diff(dayjs(detalisParams.value.startDate), 'day')
  if(duration > 7){ rangeType.value = '0' }
  if(duration === 7) { rangeType.value = '1' }
  if(duration < 7){ rangeType.value = '2' }

  searchHandle()
}
const searchHandle = () => {
  fetchData(detalisParams.value)
  fetchUserData(detalisParams.value as any)
  // 获取警告阈值
  getAlarmHandle()
}





// 展示用户下载详情
const detailsFg = ref<boolean>(false)
let userDownloadHistory: any = ref([])
const showUserFilesDetails = (row: any) => {
  user_identify.value = true
  fileDetailsApi({
    ...detalisParams.value,
    userId: row.userId
  }).then((rep) => {
    userDownloadHistory.value = rep
    user_identify.value = false
    detailsFg.value = true
  }).catch(() => {
    user_identify.value = false
  })
}


// 下载导出Excel
const exportExcelHandle = async () => {
  MI_identify.value = true
  try {
    await exportHandle(exportExcelApi, detalisParams.value)
    ElMessage.success('下载成功')
    MI_identify.value = false
  } catch (error) {
    MI_identify.value = false
  }
  
}


// 跳转响应目录
const switchPage = (row: any) => {
  window.open(window.location.origin + '/#/drive' + row.location + row.name, '_blank');
  // window.location.href = window.location.origin + '/#/drive' + row.location + row.name
  // window.location.replace(window.location.origin + '/#' + item.meta.path)
  // window.location.reload();
}

// 设置转PDF
const convertPdfFg = ref<boolean>(false)
const submitFileType = () => {
  convertPdfFg.value = true
  settingfile_typeApi({fileType: toPdfStr.value}, {contentType: 'formData'}).then(() => {
    ElMessage.success('成功')
    convertPdfFg.value = false
    settingFg.value = false
    getAlarmHandle()
  }).catch(() => [
    convertPdfFg.value = false
  ])
}
// 禁用字体
const illegalFonts=ref("")
const settingDisabledFont=()=>{
	convertPdfFg.value = true
	let formdata=new FormData()
	formdata.append('disabledFont',illegalFonts.value)
	settingDisabledFontApi(formdata).then(res=>{
		ElMessage.success('成功')
		convertPdfFg.value = false
		settingFg.value = false
		getAlarmHandle()
	}).catch(()=>{
		convertPdfFg.value = false
	})
}

onBeforeMount(() => {})
onActivated(() => {
  dataChangeHandle()
})


return (_ctx: any,_cache: any) => {
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_date_picker = _resolveComponent("el-date-picker")!
  const _component_el_divider = _resolveComponent("el-divider")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_col = _resolveComponent("el-col")!
  const _component_el_row = _resolveComponent("el-row")!
  const _component_el_dialog = _resolveComponent("el-dialog")!
  const _component_QuestionFilled = _resolveComponent("QuestionFilled")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_tooltip = _resolveComponent("el-tooltip")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_tab_pane = _resolveComponent("el-tab-pane")!
  const _component_el_tabs = _resolveComponent("el-tabs")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_el_button, {
          onClick: _cache[0] || (_cache[0] = ($event: any) => (quickSearch('0'))),
          type: _unref(rangeType) === '0' ? 'primary' : ''
        }, {
          default: _withCtx(() => [
            _hoisted_3
          ]),
          _: 1
        }, 8, ["type"]),
        _createVNode(_component_el_button, {
          onClick: _cache[1] || (_cache[1] = ($event: any) => (quickSearch('1'))),
          type: _unref(rangeType) === '1' ? 'primary' : ''
        }, {
          default: _withCtx(() => [
            _hoisted_4
          ]),
          _: 1
        }, 8, ["type"]),
        _createVNode(_component_el_button, {
          onClick: _cache[2] || (_cache[2] = ($event: any) => (quickSearch('2'))),
          type: _unref(rangeType) === '2' ? 'primary' : ''
        }, {
          default: _withCtx(() => [
            _hoisted_5
          ]),
          _: 1
        }, 8, ["type"]),
        _createVNode(_component_el_date_picker, {
          class: "ml-10",
          "unlink-panels": "",
          modelValue: _unref(detailsDate),
          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_isRef(detailsDate) ? (detailsDate).value = $event : detailsDate = $event)),
          type: "daterange",
          "range-separator": "至",
          "start-placeholder": "开始日期",
          "end-placeholder": "结束日期",
          "value-format": "YYYY-MM-DD",
          onChange: _cache[4] || (_cache[4] = ($event: any) => (dataChangeHandle()))
        }, null, 8, ["modelValue"])
      ]),
      _createElementVNode("div", null, [
        _createVNode(_component_el_button, {
          class: "ml-10",
          onClick: _cache[5] || (_cache[5] = ($event: any) => (showSetHandle()))
        }, {
          default: _withCtx(() => [
            _hoisted_6
          ]),
          _: 1
        })
      ])
    ]),
    _createVNode(_component_el_divider),
    _createElementVNode("div", _hoisted_7, [
      _hoisted_8,
      _createVNode(_component_el_button, {
        icon: "refresh",
        class: "ml-10 refreshBtn",
        onClick: _cache[6] || (_cache[6] = ($event: any) => (dataChangeHandle()))
      })
    ]),
    _createVNode(_component_el_row, { class: "mt-10" }, {
      default: _withCtx(() => [
        _createVNode(_component_el_col, { span: 16 }, {
          default: _withCtx(() => [
            _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_9, [
              _createElementVNode("div", _hoisted_10, [
                _createElementVNode("span", {
                  class: "downloadPointer",
                  onClick: _cache[7] || (_cache[7] = ($event: any) => (exportExcelHandle()))
                }, "下载Excel")
              ]),
              _createVNode(_component_el_table, {
                border: "",
                data: _unref(MI_tableData),
                "max-height": _unref(MI_height) - 40 + 'px'
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_table_column, {
                    label: "文件名",
                    prop: "filename"
                  }),
                  _createVNode(_component_el_table_column, {
                    label: "目录",
                    prop: "name"
                  }, {
                    default: _withCtx(({ row }) => [
                      ( row.name!='已删除')
                        ? (_openBlock(), _createElementBlock("span", {
                            key: 0,
                            class: "catalogue pointerText",
                            onClick: ($event: any) => (switchPage(row))
                          }, _toDisplayString(row.name), 9, _hoisted_11))
                        : (_openBlock(), _createElementBlock("span", _hoisted_12, _toDisplayString(row.name), 1))
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_table_column, {
                    label: "用户名",
                    prop: "userName"
                  }),
                  _createVNode(_component_el_table_column, {
                    label: "下载时间",
                    prop: "createdAt",
                    formatter: _unref(formatTime)
                  }, null, 8, ["formatter"])
                ]),
                _: 1
              }, 8, ["data", "max-height"])
            ])), [
              [_directive_loading, _unref(MI_identify)]
            ])
          ]),
          _: 1
        }),
        _createVNode(_component_el_col, { span: 8 }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_13, [
              _hoisted_14,
              _withDirectives((_openBlock(), _createBlock(_component_el_table, {
                class: "mt-10",
                border: "",
                data: _unref(userDownloadTable),
                "max-height": _unref(MI_height) - 45 + 'px'
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_table_column, {
                    label: "用户名",
                    prop: "userName"
                  }, {
                    default: _withCtx(({ row }) => [
                      _createElementVNode("span", {
                        class: _normalizeClass({alertText: row.number >= _unref(realAlarmVal)})
                      }, _toDisplayString(row.userName), 3)
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_table_column, {
                    label: "下载次数",
                    prop: "frequency"
                  }),
                  _createVNode(_component_el_table_column, {
                    label: "下载文件",
                    prop: "number"
                  }, {
                    default: _withCtx(({ row }) => [
                      _createElementVNode("span", {
                        class: "userDownloadFile pointerText",
                        onClick: ($event: any) => (showUserFilesDetails(row))
                      }, _toDisplayString(row.number), 9, _hoisted_15)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["data", "max-height"])), [
                [_directive_loading, _unref(user_identify)]
              ])
            ])
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_el_dialog, {
      title: "用户下载文件详情",
      modelValue: detailsFg.value,
      "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((detailsFg).value = $event)),
      width: "70%"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_table, {
          border: "",
          data: _unref(userDownloadHistory),
          "max-height": "500px"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_table_column, {
              label: "文件名",
              prop: "filename",
              "show-overflow-tooltip": ""
            }),
            _createVNode(_component_el_table_column, {
              label: "目录",
              prop: "name"
            }, {
              default: _withCtx(({ row }) => [
                _createElementVNode("span", null, _toDisplayString(row.name), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_el_table_column, {
              label: "用户名",
              prop: "userName"
            }),
            _createVNode(_component_el_table_column, {
              label: "下载时间",
              prop: "createdAt",
              formatter: _unref(formatTime)
            }, null, 8, ["formatter"])
          ]),
          _: 1
        }, 8, ["data"])
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_el_dialog, {
      title: "设置",
      modelValue: settingFg.value,
      "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((settingFg).value = $event))
    }, {
      default: _withCtx(() => [
        _withDirectives((_openBlock(), _createBlock(_component_el_tabs, { type: "border-card" }, {
          default: _withCtx(() => [
            _createVNode(_component_el_tab_pane, { label: "告警设置" }, {
              default: _withCtx(() => [
                _createVNode(_component_el_tooltip, {
                  effect: "dark",
                  content: '用户下载超过'+ _unref(alarmThreshold) +'个文件，其用户名将在用户下载详情表中显示为红色',
                  placement: "top"
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("span", _hoisted_16, [
                      _hoisted_17,
                      _createVNode(_component_el_icon, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_QuestionFilled)
                        ]),
                        _: 1
                      })
                    ])
                  ]),
                  _: 1
                }, 8, ["content"]),
                _createVNode(_component_el_input, {
                  maxlength: "3",
                  modelValue: _unref(alarmThreshold),
                  "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => (_isRef(alarmThreshold) ? (alarmThreshold).value = $event : alarmThreshold = $event)),
                  class: "alarmInput"
                }, null, 8, ["modelValue"]),
                _hoisted_18,
                _hoisted_19,
                _createVNode(_component_el_tooltip, {
                  effect: "dark",
                  content: _unref(remindDay) +'天内下载超过告警阈值的用户，将会收到邮件提醒',
                  placement: "top"
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("span", _hoisted_20, [
                      _hoisted_21,
                      _createVNode(_component_el_icon, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_QuestionFilled)
                        ]),
                        _: 1
                      })
                    ])
                  ]),
                  _: 1
                }, 8, ["content"]),
                _createVNode(_component_el_input, {
                  maxlength: "3",
                  modelValue: _unref(remindDay),
                  "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => (_isRef(remindDay) ? (remindDay).value = $event : remindDay = $event)),
                  class: "alarmInput"
                }, null, 8, ["modelValue"]),
                _hoisted_22,
                _hoisted_23,
                _createVNode(_component_el_divider),
                _hoisted_24,
                _createVNode(_component_el_row, { class: "mt-30" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_col, { span: 2 }, {
                      default: _withCtx(() => [
                        _hoisted_25
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_col, { span: 22 }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_input, {
                          modelValue: _unref(title),
                          "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => (_isRef(title) ? (title).value = $event : title = $event)),
                          placeholder: "标题"
                        }, null, 8, ["modelValue"]),
                        _createVNode(_component_el_input, {
                          modelValue: _unref(content),
                          "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => (_isRef(content) ? (content).value = $event : content = $event)),
                          class: "mt-20",
                          rows: 10,
                          type: "textarea",
                          placeholder: "请输入邮件内容"
                        }, null, 8, ["modelValue"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createElementVNode("div", _hoisted_26, [
                  _createVNode(_component_el_button, {
                    onClick: cancelAlarm,
                    disabled: alarmBtnFg.value
                  }, {
                    default: _withCtx(() => [
                      _hoisted_27
                    ]),
                    _: 1
                  }, 8, ["disabled"]),
                  _createVNode(_component_el_button, {
                    type: "primary",
                    onClick: setAlarmHandle,
                    loading: alarmBtnFg.value
                  }, {
                    default: _withCtx(() => [
                      _hoisted_28
                    ]),
                    _: 1
                  }, 8, ["loading"])
                ])
              ]),
              _: 1
            }),
            _createVNode(_component_el_tab_pane, { label: "转PDF" }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: _unref(toPdfStr),
                  "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => (_isRef(toPdfStr) ? (toPdfStr).value = $event : toPdfStr = $event)),
                  rows: 12,
                  type: "textarea"
                }, null, 8, ["modelValue"]),
                _hoisted_29,
                _hoisted_30,
                _hoisted_31,
                _createElementVNode("div", _hoisted_32, [
                  _createVNode(_component_el_button, { onClick: cancelAlarm }, {
                    default: _withCtx(() => [
                      _hoisted_33
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_button, {
                    type: "primary",
                    onClick: _cache[14] || (_cache[14] = ($event: any) => (submitFileType()))
                  }, {
                    default: _withCtx(() => [
                      _hoisted_34
                    ]),
                    _: 1
                  })
                ])
              ]),
              _: 1
            }),
            _createVNode(_component_el_tab_pane, { label: "禁用字体" }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: illegalFonts.value,
                  "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((illegalFonts).value = $event)),
                  rows: 12,
                  type: "textarea"
                }, null, 8, ["modelValue"]),
                _hoisted_35,
                _hoisted_36,
                _hoisted_37,
                _hoisted_38,
                _hoisted_39,
                _createElementVNode("div", _hoisted_40, [
                  _createVNode(_component_el_button, { onClick: cancelAlarm }, {
                    default: _withCtx(() => [
                      _hoisted_41
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_button, {
                    onClick: settingDisabledFont,
                    type: "primary"
                  }, {
                    default: _withCtx(() => [
                      _hoisted_42
                    ]),
                    _: 1
                  })
                ])
              ]),
              _: 1
            })
          ]),
          _: 1
        })), [
          [_directive_loading, convertPdfFg.value]
        ])
      ]),
      _: 1
    }, 8, ["modelValue"])
  ]))
}
}

})